import { render, staticRenderFns } from "./PdaMenuScreen.vue?vue&type=template&id=b910aa4c&scoped=true&"
import script from "./PdaMenuScreen.vue?vue&type=script&lang=js&"
export * from "./PdaMenuScreen.vue?vue&type=script&lang=js&"
import style0 from "./PdaMenuScreen.vue?vue&type=style&index=0&id=b910aa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b910aa4c",
  null
  
)

export default component.exports